import Index from './Index.vue';

export default {
  path: 'ramo-atividade',
  name: 'ramo-atividade',
  component: Index,
};
